/** Used by Datadog init so tests can stub hostname without touching `window.location`. */
export const getDatadogBrowserHostname = (): string => window.location.hostname
